/* eslint-disable react-hooks/rules-of-hooks */
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuthorizationContext } from '../../components/AuthorizationProvider/AuthorizationProvider';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import { getAllowedOperations } from '../../utils/authUtils';

const AllowedOperationsContext = createContext();

const withAllowedOperationsProvider = (
  WrappedComponent,
  isAggregateLine = false,
  ...resourceTypes
) => props => {
  const { authPolicies } = useAuthorizationContext();
  const [plant] = usePlantAndLinesStore().plantState;
  const [line] = usePlantAndLinesStore().lineState;
  const [aggregateLine] = usePlantAndLinesStore().aggregateLineState;
  const [allowedOperations, setAllowedOperations] = useState([]);
  const [allowedOperationsWithValue, setAllowedOperationsWithValues] = useState(
    [],
  );

  useEffect(() => {
    const evaluatedOperationsForAllResourceTypes = getAllowedOperations(
      plant,
      !isAggregateLine ? line : aggregateLine,
      resourceTypes,
      authPolicies,
    );
    const operations = evaluatedOperationsForAllResourceTypes.map(
      i => i.operation,
    );
    setAllowedOperationsWithValues(evaluatedOperationsForAllResourceTypes);
    setAllowedOperations(operations);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plant, line, aggregateLine, authPolicies]);

  return (
    <AllowedOperationsContext.Provider
      value={{ allowedOperations, allowedOperationsWithValue }}
    >
      <WrappedComponent {...props} />
    </AllowedOperationsContext.Provider>
  );
};

export default withAllowedOperationsProvider;

export const useAllowedOperationsContext = () =>
  useContext(AllowedOperationsContext);
